import { useContext } from 'react';

import {
  CurrentUserContext,
  CurrentUserContextValue,
} from '../providers/CurrentUserProvider';

export const useCurrentUser = () =>
  useContext<CurrentUserContextValue>(CurrentUserContext).user;
